<template>
  <div class="min-h-screen bg-off-black">
    <div class="container mx-auto px-4 py-16">
      <!-- Hero Section -->
      <div class="text-center mb-16">
        <h1 class="text-5xl md:text-6xl font-serif font-semibold mb-6 text-vibe-green">
          Smart Onboarding for UAE Professionals
        </h1>
        <p class="text-xl md:text-2xl text-gray-green max-w-3xl mx-auto">
          Streamline CDD compliance and client onboarding with AI-powered solutions designed for legal and accounting professionals operating in the UAE
        </p>
      </div>

      <!-- Freebie Cards Section -->
      <div class="max-w-3xl mx-auto">
        <h2 class="text-3xl md:text-4xl font-serif font-semibold text-white text-center mb-12">
          Free Resources
        </h2>

        <div class="grid md:grid-cols-2 gap-8">
          <!-- UAE CDD Effectiveness Checklist Card -->
          <div class="bg-green-700 rounded-lg overflow-hidden shadow-xl border border-vibe-green hover:border-vibe-green transition-all duration-300 hover:transform hover:scale-105 relative">
            <div class="absolute top-4 right-4 bg-vibe-green text-black text-xs font-bold px-3 py-1 rounded-full">
              NEW
            </div>
            <div class="p-8">
              <div class="bg-vibe-green rounded-full w-16 h-16 flex items-center justify-center mb-6">
                <svg class="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>

              <h3 class="text-2xl font-semibold text-vibe-green mb-4">
                2026 CDD Effectiveness Checklist
              </h3>

              <p class="text-gray-green mb-6 leading-relaxed">
                Comprehensive checklist for UAE firms assessing CDD effectiveness under the latest 2026 compliance standards.
              </p>

              <ul class="text-sm text-gray-green mb-6 space-y-2">
                <li class="flex items-start">
                  <span class="text-vibe-green mr-2">✓</span>
                  <span>CDD effectiveness assessment</span>
                </li>
                <li class="flex items-start">
                  <span class="text-vibe-green mr-2">✓</span>
                  <span>Risk-based approach guidance</span>
                </li>
                <li class="flex items-start">
                  <span class="text-vibe-green mr-2">✓</span>
                  <span>Compliance framework alignment</span>
                </li>
                <li class="flex items-start">
                  <span class="text-vibe-green mr-2">✓</span>
                  <span>Practical implementation steps</span>
                </li>
              </ul>

              <router-link
                to="/uae/cdd-effectiveness-checklist"
                class="btn-primary w-full text-center inline-block"
              >
                Download Free Checklist
              </router-link>
            </div>
          </div>

          <!-- UAE Beneficial Ownership Verification Toolkit Card -->
          <div class="bg-green-700 rounded-lg overflow-hidden shadow-xl border border-vibe-green hover:border-vibe-green transition-all duration-300 hover:transform hover:scale-105 relative">
            <div class="absolute top-4 right-4 bg-vibe-green text-black text-xs font-bold px-3 py-1 rounded-full">
              NEW
            </div>
            <div class="p-8">
              <div class="bg-vibe-green rounded-full w-16 h-16 flex items-center justify-center mb-6">
                <svg class="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>

              <h3 class="text-2xl font-semibold text-vibe-green mb-4">
                2026 Beneficial Ownership Verification Toolkit
              </h3>

              <p class="text-gray-green mb-6 leading-relaxed">
                Practical toolkit for UAE firms verifying beneficial ownership under the latest 2026 compliance standards.
              </p>

              <ul class="text-sm text-gray-green mb-6 space-y-2">
                <li class="flex items-start">
                  <span class="text-vibe-green mr-2">✓</span>
                  <span>UAE beneficial ownership verification requirements</span>
                </li>
                <li class="flex items-start">
                  <span class="text-vibe-green mr-2">✓</span>
                  <span>Step-by-step verification checklist</span>
                </li>
                <li class="flex items-start">
                  <span class="text-vibe-green mr-2">✓</span>
                  <span>Risk-based approach guidance</span>
                </li>
                <li class="flex items-start">
                  <span class="text-vibe-green mr-2">✓</span>
                  <span>Practical implementation steps</span>
                </li>
              </ul>

              <router-link
                to="/uae/beneficial-ownership-verification-toolkit"
                class="btn-primary w-full text-center inline-block"
              >
                Download Free Toolkit
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- CTA Section -->
      <div class="max-w-4xl mx-auto mt-20 bg-green-600 rounded-lg p-12 text-center border border-vibe-green">
        <h2 class="text-3xl md:text-4xl font-serif font-semibold text-vibe-green mb-6">
          Ready to Automate Your Onboarding?
        </h2>
        <p class="text-lg text-white mb-8">
          See how Marker AI can help you streamline workflows, strengthen compliance, and accelerate commercial momentum. Book a demo to learn more.
        </p>
        <a
          href="https://www.marker-ai.com/contact-us"
          class="btn-primary text-lg"
        >
          Get in Touch
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UAEHub',
};
</script>
